import {Reducer} from "redux";
import {loadingMatcher, REQUEST_POSTFIX} from "./types";
import {PayloadAction} from "typesafe-actions/dist/type-helpers";

export const loadingReducer : Reducer<Record<string, boolean>, PayloadAction<string, any>> = (state = {}, action) => {
    const { type } = action;
    const matches = loadingMatcher.exec(type);

    if (!matches) {
        return state;
    }

    const [, requestName, requestState] = matches;
    return {
        ...state,
        [requestName]: requestState === REQUEST_POSTFIX
    };
};
